import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'dokumenPelantikan'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const masterRegion = 'Master/Region/list/'

export const dokumenpelantikanCreate = 'Kepegawaian/DokumenPelantikan/create/'
export const generateDocument = 'Kepegawaian/DokumenPelantikan/generate/'
export const generateDocumentPakta = 'Kepegawaian/DokumenPelantikan/generate_pakta/'
export const generateDocumentSPP = 'Kepegawaian/DokumenPelantikan/generate_spp/'
export const generateDocumentSPMJ = 'Kepegawaian/DokumenPelantikan/generate_spmj/'
export const generateDocumentSPMT = 'Kepegawaian/DokumenPelantikan/generate_spmt/'
export const getDocPelantikan = 'Kepegawaian/DokumenPelantikan/get_dokumen/'
export const getDocPakta = 'Kepegawaian/DokumenPelantikan/get_dokumen/'
export const getDocSPP = 'Kepegawaian/DokumenPelantikan/get_dokumen/'
export const getDocSPMJ = 'Kepegawaian/DokumenPelantikan/get_dokumen/'
export const getDocSPMT = 'Kepegawaian/DokumenPelantikan/get_dokumen/'
export const dokumenpelantikanList = 'Kepegawaian/DokumenPelantikan/list/'
export const dokumenpelantikanDetail = 'Kepegawaian/DokumenPelantikan/detail/'
export const dokumenpelantikanUpdate = 'Kepegawaian/DokumenPelantikan/update/'
export const dokumenpelantikanInactive = 'Kepegawaian/DokumenPelantikan/inactive/'
export const dokumenpelantikanActive = 'Kepegawaian/DokumenPelantikan/active/'
export const dokumenpelantikanListPegawai = 'Kepegawaian/DokumenPelantikan/list_pegawai/'
export const dokumenpelantikanListdokumenpelantikan = 'Kepegawaian/DokumenPelantikan/list_dokumenpelantikan/'
export const ListJabatan = 'Kepegawaian/DokumenPelantikan/position/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}